import { useNavigate } from 'react-router-dom'

import errorCup from '@/assets/imgs/error-cup.png'
import { NOT_FOUND as dict } from '@/resources/dict'

import * as S from './styles'

const NotFound = () => {
  const navigate = useNavigate()

  const goToOrdersPage = () => {
    navigate('/poc-orders')
  }

  return (
    <S.Wrapper>
      <S.Content>
        <S.Image src={errorCup} alt="error-cup" />
        <S.Title>{dict.title}</S.Title>
        <S.Subtitle>{dict.subtitle}</S.Subtitle>
        <S.CustomButton id="go-to-orders-page" onClick={goToOrdersPage}>
          {dict.button}
        </S.CustomButton>
      </S.Content>
    </S.Wrapper>
  )
}

export default NotFound
